import React from "react";

export const useComponentDidMount = (callback: () => void | Promise<void>) => {
    React.useEffect(() => {
        callback();
    }, []);
}